export enum AuthState {
  NotAuthenticated,
  Client,
  Driver,
  Liaison,
}
